// Browsers report some colours (for example Angular Material's disabled states) as color(srgb r g b / a), which
// html2canvas can't read and fails on. These rewrite them as rgba() in the copy of the page html2canvas draws.

// the colour properties html2canvas reads
const COLOUR_PROPERTIES = ['color', 'background-color', 'border-top-color', 'border-right-color', 'border-bottom-color',
    'border-left-color', 'outline-color', 'text-decoration-color', 'column-rule-color', 'caret-color', 'fill', 'stroke',
    'box-shadow', 'text-shadow', 'background-image', '-webkit-text-stroke-color', '-webkit-text-fill-color']

const SRGB_COLOUR = /color\(srgb\s+([\d.e-]+)\s+([\d.e-]+)\s+([\d.e-]+)(?:\s*\/\s*([\d.e-]+%?))?\s*\)/g

export const srgbToRgba = (value:string) => value.replace(SRGB_COLOUR, (_match, r, g, b, a) => {
    const channel = (c:string) => Math.round(Math.min(1, Math.max(0, parseFloat(c))) * 255)
    const alpha = a === undefined ? 1 : a.endsWith('%') ? parseFloat(a) / 100 : parseFloat(a)
    return `rgba(${channel(r)}, ${channel(g)}, ${channel(b)}, ${alpha})`
})

export const convertModernColours = (clone:Document) => {
    const view = clone.defaultView
    if (!view) return
    clone.body.querySelectorAll<HTMLElement>('*').forEach(e => {
        const style = view.getComputedStyle(e)
        COLOUR_PROPERTIES.forEach(property => {
            const value = style.getPropertyValue(property)
            if (value.includes('color(')) e.style.setProperty(property, srgbToRgba(value))
        })
    })
}
